import axios from 'axios';
import { builderSurfaceJsonContentHeader } from './restApiHeaderUtils';

const loadCollectionItem = async (projectId, uri) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  let response = await axios.get(uri, header);
  if (response && response.data) {
    const { code, content } = response.data;
    if (code !== 200) {
      return [];
    }
    return content;
  }
};

export const getItemsOfSelectedCollection = async (
  projectId,
  collectionName,
  version,
  fieldsToInclude = [],
) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  let params = '';
  if (fieldsToInclude.length) {
    fieldsToInclude.push('uuid');
    fieldsToInclude = fieldsToInclude.map((field) => `project_${field}=true`);
    params = fieldsToInclude.join('&');
  }
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/${
    params ? '?' + params : ''
  }`;
  const response = await axios.get(url, header);
  const { content } = response.data;
  return { data: content };
};

export const getCollectionItemList = async (projectId, version, collectionName, query = null) => {
  const params = new URLSearchParams();
  if (query) {
    if (query.searchTerm) {
      params.append('searchTerm', query.searchTerm);
    } else if (query.limit) {
      params.append('limit', query.limit);
    }
  }
  const queryString = params.toString();
  const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/${
    queryString ? `?${queryString}` : ''
  }`;
  return await loadCollectionItem(projectId, uri);
};
export const getCollectionItemByIds = async (projectId, version, collectionName, ids = []) => {
  const uri = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/itemsbyids`;
  const config = builderSurfaceJsonContentHeader(projectId);
  let result = [];
  let response = await axios.post(uri, { ids }, config);
  if (response && response.status === 200) result = response.data;
  return result;
};

export const getUserRoleFromApi = async (projectId, version) => {
  return await getCollectionItemList(projectId, version, 'role');
};

export const formatUpdatedAgo = (updatedAt) => {
  if (!updatedAt) return '';

  const updatedDate = new Date(updatedAt);

  if (Number.isNaN(updatedDate.getTime())) return '';

  const diffInSeconds = Math.round((updatedDate.getTime() - Date.now()) / 1000);
  const absoluteDiff = Math.abs(diffInSeconds);
  const relativeTimeFormat = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

  if (absoluteDiff < 60) {
    return relativeTimeFormat.format(diffInSeconds, 'second');
  }

  const diffInMinutes = Math.round(diffInSeconds / 60);
  if (Math.abs(diffInMinutes) < 60) {
    return relativeTimeFormat.format(diffInMinutes, 'minute');
  }

  const diffInHours = Math.round(diffInMinutes / 60);
  if (Math.abs(diffInHours) < 24) {
    return relativeTimeFormat.format(diffInHours, 'hour');
  }

  const diffInDays = Math.round(diffInHours / 24);
  if (Math.abs(diffInDays) < 30) {
    return relativeTimeFormat.format(diffInDays, 'day');
  }

  const diffInMonths = Math.round(diffInDays / 30);
  if (Math.abs(diffInMonths) < 12) {
    return relativeTimeFormat.format(diffInMonths, 'month');
  }

  return relativeTimeFormat.format(Math.round(diffInMonths / 12), 'year');
};
